<ion-segment [(ngModel)]="plant" (ionChange)="segmentChanged($event)">
  <ion-segment-button [value]="options.CONVERTING">
    <ion-label>CONV</ion-label>
  </ion-segment-button>
  <ion-segment-button [value]="options.CP" checked>
    <ion-label>CP</ion-label>
  </ion-segment-button>
</ion-segment>